import { validateEmail } from '@Utils/Email';
import { forgotPasswordDialogReducerKey } from './ForgotPasswordDialogConstants';

export function forgotPasswordDialog(state) {
  return state.get(forgotPasswordDialogReducerKey);
}

export function email(state) {
  return forgotPasswordDialog(state).get('email');
}

export function isEmailValid(state) {
  return validateEmail(email(state));
}

export function isLoading(state) {
  return forgotPasswordDialog(state).get('isLoading');
}

export function result(state) {
  return forgotPasswordDialog(state).get('result');
}
